import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TourProvider } from './components/ui/TourManager';

/**
 * Monkey-patch performance.measure to prevent DataCloneError in React 19 dev mode.
 * This is a known issue where Symbols (like react.forward_ref) cannot be cloned.
 */
if (typeof window !== 'undefined' && window.performance && window.performance.measure) {
  const originalMeasure = window.performance.measure;
  window.performance.measure = function (name, startMark, endMark) {
    try {
      return originalMeasure.call(window.performance, name, startMark, endMark);
    } catch (e) {
      if (e && (e.name === 'DataCloneError' || e.code === 25)) {
        // If measurement fails due to cloning (known React 19 dev bug),
        // just ignore it to prevent app crash.
        return null;
      }
      throw e;
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TourProvider>
      <App />
    </TourProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
